import React,{useEffect} from 'react';
import axios from 'axios'
import Swal from 'sweetalert2';
import CardImage from './cardimage/CardImage';
import { formStyles } from './form-style/FormStyle';
import './App.css'


export default function Index() {
  const [loading,setLoading] = React.useState(false)
  const [card,setCard] = React.useState(null);
  const [cardHolder,setCardHolder] = React.useState('CARD HOLDER')
  const [cardNumber,setCardNumber] = React.useState('')
  const [mm,setMM] = React.useState('')
  const [yy,setYY] = React.useState('')
  
  const click = async()=> {
    try{
        setLoading(true)
        const cardData = await card.getData()
        if(cardData.error){
          throw Error(cardData.error)
        }
        const result = await card.getNonceToken();
        const gatewayApi = process.env.REACT_APP_API_URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        const _params = Object.fromEntries(urlSearchParams.entries());
        let payload = JSON.stringify({
          ...result,
          ref:_params.ref.split('|')[0]
        });
        const config = {
          headers: {
            'Content-Type': 'application/json',
          },
        };        
        const res = await axios.post(gatewayApi,payload,config)
        if(res && res.status===200) return window.location.replace(`${process.env.REACT_APP_VALA_CALLBACK}`)  
    }catch(err){
      if(err.response || err.request){
        return Swal.fire({
          icon: 'error',
          text:  'Please try again !',
          width: '350',
          confirmButtonColor: '#FF0000',
        })
      }else {
        return Swal.fire({
          icon: 'error',
          text:  err.message,
          width: '350',
          confirmButtonColor: '#FF0000',
        })
      }
    }finally{
      setLoading(false)
    }
  }

  useEffect(() => {
    const tokenizationSourceKey = process.env.REACT_APP_MAJICPAY_SOURCE_KEY;
    const hostedTokenization = new window.HostedTokenization(tokenizationSourceKey);
    const cardForm = hostedTokenization.create('card-form');
    cardForm.mount('#my-div')
    .on('input', (event)=>{
      setCardNumber(event.result && event.result.maskedCard)
      setMM(event.result && event.result.expiryMonth)
      setYY(event.result && event.result.expiryYear)
    });
    const _card = document.getElementById('my-div');
    setCard(cardForm)
    cardForm.setStyles(formStyles);  
    return () => {
      _card.innerHTML = '';
    };
  }, []);

  useEffect(()=>{
    const urlSearchParams = new URLSearchParams(window.location.search);
    const _params = Object.fromEntries(urlSearchParams.entries());
    setCardHolder(_params.ref.slice(_params.ref.indexOf('|') + 1) || 'CARD HOLDER')
   
  },[])

  return(
    <div>
        <CardImage  name={cardHolder} number={cardNumber} mm={mm} yy={yy} />  
        <div className="form-container">
            <div className="field-container">
                {/* <label for="name">Name</label> */}
                <input id="name" maxlength="20" type="text" value={cardHolder} disabled />
            </div>
            <div id="my-div"></div>
            <div>
              <button
                style={{background:'#007bff', 
                        color:'white', 
                        fontSize:'1rem',
                        outline:'none',
                        border:'2px solid #007bff', 
                        borderRadius: '4px',
                        width:'100%', 
                        transition:'.5s ease',
                        letterSpacing: '.8px',
                        fontWeight:'600 !important',
                        cursor: 'pointer',
                        padding:'14px 16px'}}
                onClick={click}
                >
               {loading ? 'Processing...' : 'Confirm and Pay'}
             </button>
          </div>
          
        </div>
    </div>
   )   
}